import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { useLocalization } from 'hooks/useLocalization';
import { Alert, Collapse } from '@mui/material';
import CollapsedAlert from 'components/shared/CollapsedAlert';

import { formatNumberWithSpacesAndRounding, getSingularOrPluralCode } from 'utils/formatUtils';

interface ActivityTypeTabButtonProps {
	activityId: number;
	activityType: 'private' | 'group';
	isSelected: boolean;
	onClick: () => void;
}

function ActivityTypeTabButton({ activityId, activityType, isSelected, onClick }: ActivityTypeTabButtonProps) {
	const { getStr } = useLocalization();
	const { selectedCurrencyCode, getTotalPaxQty, getActivityInteractionData, paxArr } = useActivityShopUI();
	const activityInteractionData = getActivityInteractionData(activityId);

	if (!selectedCurrencyCode || !activityInteractionData) return null;

	const activityTotalPrice = activityInteractionData.totalPrice[activityType];

	return(
		<div
			onClick={onClick}
			className={`activity-tab activity-tab-${activityType} ${isSelected ? '' : 'activity-tab-not-selected'}`}
		>
			<div style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{activityType === 'private' ? getStr('Private') : getStr('Group')}</div>
			<CollapsedAlert isVisible={activityTotalPrice === 0} severity="error" isSelected={isSelected} isGrayIfNotSelected={true} isCentered={true} isUppercase={true}>
				{getStr('Price_unset')}
			</CollapsedAlert>
			<Collapse in={activityTotalPrice > 0}>
				<div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
					{formatNumberWithSpacesAndRounding(activityTotalPrice / getTotalPaxQty(paxArr))} {selectedCurrencyCode} {getStr('PER_PERSON_ABBREV')}
				</div>
				<div style={{ fontSize: '0.8em', opacity: '0.7' }}>
					{formatNumberWithSpacesAndRounding(activityTotalPrice)} {selectedCurrencyCode} ({getTotalPaxQty(paxArr)} {getStr(getSingularOrPluralCode(getTotalPaxQty(paxArr), 'person', 'people'))})
				</div>
			</Collapse>
		</div>
	);
}

export default ActivityTypeTabButton;